"use client"

import { useState, useEffect } from "react"
import "./Testimonials.css"
import waffa from "../assets/wafaa.png"
import awais from "../assets/awais.png"
import laraib from "../assets/laraib.png"
import { BiSolidQuoteAltLeft } from "react-icons/bi";
import { BiSolidQuoteAltRight } from "react-icons/bi";

const testimonials = [
  {
    id: 1,
    text: "Through our interactions, I have found Muhammad to be a professional with a strong interest in the SaaS field. He is passionate about developing technical solutions and has a solid understanding of the industry. I wish him all the best in his career.",
    author: "Wafaa Maresh",
    role: "Freelance UX Designer",
    avatar: waffa,
    linkedin: "https://www.linkedin.com/in/awesomaa1/details/recommendations/?detailScreenTabIndex=0"
  },
  {
    id: 2,
    text: " had the pleasure of working with Usama, a skilled UI/UX Designer, who played a key role in designing intuitive and user-friendly interfaces, especially for SaaS applications. His ability to balance aesthetics with functionality, collaborate effectively with developers, and refine designs based on user feedback made him an invaluable asset to our team.",
    author: "Awais Jafar",
    role: "Technical Project Manager , Fabtechsol",
    avatar: awais,
    linkedin: "https://www.linkedin.com/in/awesomaa1/details/recommendations/?detailScreenTabIndex=0"
  },
  {
    id: 3,
    text: "I highly recommend Muhammad Usama as an amazing UI/UX designer. His passion for design is evident in every project. Having worked alongside him on multiple projects, I found him incredibly supportive and collaborative. He understands client requirements thoroughly and goes above and beyond to deliver outstanding results. His teamwork, creativity, and dedication make him an invaluable asset to any project.",
    author: "Laraib Abid",
    role: "Team Lead, Devsinc",
    avatar: laraib,
    linkedin: "https://www.linkedin.com/in/awesomaa1/details/recommendations/?detailScreenTabIndex=0"
  },
]

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isAutoPlaying, setIsAutoPlaying] = useState(true)

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length)
  }

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + testimonials.length) % testimonials.length)
  }

  useEffect(() => {
    let interval

    if (isAutoPlaying) {
      interval = setInterval(() => {
        nextSlide()
      }, 2500)
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [isAutoPlaying, currentIndex])

  const handleMouseEnter = () => setIsAutoPlaying(false)
  const handleMouseLeave = () => setIsAutoPlaying(true)

  return (
    <section className="testimonials">
      <div className="container">
        <h2 className="section-title">Referrals</h2>

        <div className="testimonials-slider" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <button className="control-btn prev-btn" onClick={prevSlide}>
            &#8249;
          </button>

          <div className="testimonial-content">
            <div className="quote-container">
              <span className="quote-mark left"><BiSolidQuoteAltLeft color="#FF8C00" /></span>
              <p className="testimonial-text">
                {testimonials[currentIndex].text}
              </p>
              <span className="quote-mark right"><BiSolidQuoteAltRight /></span>
            </div>

            <div className="testimonial-author">
              <img
                src={testimonials[currentIndex].avatar || "/placeholder.svg"}
                alt={testimonials[currentIndex].author}
                className="author-avatar"
              />
              <div className="author-info">
                <div className="author-name">{testimonials[currentIndex].author}</div>
                <div className="author-role">{testimonials[currentIndex].role}</div>
                <a href={testimonials[currentIndex].linkedin} className="linkedin-btn">
                  See On LinkedIn
                </a>
              </div>
            </div>
          </div>

          <button className="control-btn next-btn" onClick={nextSlide}>
            &#8250;
          </button>
        </div>
      </div>
    </section>
  )
}

export default Testimonials